import { VOPage } from "../model/DataStructure.js";
import { MenuBar, MenuBarItem } from "./MenuBar.js";

export interface FooterOptions {
    container: HTMLElement;
    pages: VOPage[];
}

export class Footer {

    private _element: HTMLElement;
    private _items: FooterItem[] = [];
    private _controlLeft: MenuBar;
    private _controlRight: MenuBar;
    private _title: MenuBarItem;

    constructor(options: FooterOptions) {
        this._element = document.createElement("div");
        this._element.className = "footer";
        this._element.innerHTML = `
        <div class="footer__fill"></div>
        <a class="footer__logo" href="http://signumquartet.com/" target="_blank"></a>
        <div class="footer__item-list"></div>        
        <div class="footer__overlay e5-hidden">
            <div class="footer__overlay-background"></div>
            <div class="footer__overlay-box">
                <div class="footer__overlay-menu"></div>
                <div class="footer__overlay-content"></div>
            </div>
        </div>
        `;

        this._controlLeft = new MenuBar({
            container: this._element.querySelector(".footer__overlay-menu"),
            direction: "horizontal"
        });

        this._controlRight = new MenuBar({
            container: this._element.querySelector(".footer__overlay-menu"),
            direction: "horizontal"
        });

        this._title = this._controlLeft.add({
            label: ""
        });

        this._controlRight.add({
            icon: "fal fa-times",
            onTrigger: (button) => {
                this.close();

            }
        });

        this._element.querySelector(".footer__overlay-background")
            .addEventListener("click", () => {
                this.close();
            });

        for (let page of options.pages) {
            this._items.push(new FooterItem({
                container: this._element.querySelector(".footer__item-list"),
                page: page,
                onClick: (page) => {
                    this.open(page);
                }
            }));
        }

        options.container.append(this._element);
    }

    private close(): void {
        this._element.querySelector(".footer__overlay").classList.add("e5-hidden");
    }

    private open(page: VOPage): void {
        const o = this._element.querySelector(".footer__overlay");
        this._title.label = page.title;
        this._element.querySelector(".footer__overlay-content").innerHTML = page.content;
        o.classList.remove("e5-hidden");
    }
}

interface FooterItemOptions {
    container: HTMLElement;
    page: VOPage;
    onClick?: (page: VOPage) => void;
}

class FooterItem {

    public onClick = e5.Signal.create<[VOPage]>();

    private _element: HTMLAnchorElement;

    constructor(options: FooterItemOptions) {
        this._element = document.createElement("a");
        this._element.className = "footer__item";
        this._element.href = "#";
        this._element.textContent = options.page.title;
        this._element.addEventListener("click", () => {
            this.onClick.dispatch(options.page);
        });
        options.container.append(this._element);

        if (typeof options.onClick === "function") {
            this.onClick.add(options.onClick);
        }
    }
}